import { Pipe, PipeTransform } from '@angular/core';
import { Filter } from '../models';

@Pipe({ name: 'filterValueLabel' })
export class FilterValueLabelPipe implements PipeTransform {
  transform(filter: Filter, value: any): string {
    return filter.getValueLabel(value);
  }
}
